export default function post(state = 0, action) {
  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/post.js